export const handleTableInputKeyDown = (event) => {
  const { key, currentTarget } = event;
  if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(key)) return;
  if (currentTarget.readOnly || currentTarget.disabled) return;

  const table = currentTarget.closest("table");
  const cell = currentTarget.closest("td, th");
  const row = currentTarget.closest("tr");
  if (!table || !cell || !row) return;

  const valueLength = String(currentTarget.value ?? "").length;
  if (key === "ArrowLeft" && currentTarget.selectionStart > 0) return;
  if (key === "ArrowRight" && currentTarget.selectionEnd < valueLength) return;

  const writableSelector = "input:not([readonly]):not([disabled])";
  const allInputs = Array.from(table.querySelectorAll(writableSelector));
  const inputIndex = allInputs.indexOf(currentTarget);
  let target = null;

  if (key === "ArrowLeft") {
    target = allInputs[inputIndex - 1] || null;
  } else if (key === "ArrowRight") {
    target = allInputs[inputIndex + 1] || null;
  } else {
    const rows = Array.from(table.querySelectorAll("tbody tr"));
    const rowIndex = rows.indexOf(row);
    const cellIndex = Array.from(row.children).indexOf(cell);
    const step = key === "ArrowDown" ? 1 : -1;

    for (let nextRowIndex = rowIndex + step; nextRowIndex >= 0 && nextRowIndex < rows.length; nextRowIndex += step) {
      const nextCell = rows[nextRowIndex].children[cellIndex];
      target = nextCell?.querySelector(writableSelector) || null;
      if (target) break;
    }
  }

  if (!target) return;
  event.preventDefault();
  target.focus();
  target.select?.();
};
